import React from 'react';
import css from './SectionPaymentPlanMaybe.module.css';

/**
 * Surfaces the payment-plan option on the listing page so renters know they
 * can split the cost before they click through to checkout. Hidden if the host
 * has set publicData.paymentPlansEnabled to false.
 */
const SectionPaymentPlanMaybe = props => {
  const { publicData } = props;
  if (publicData?.paymentPlansEnabled === false) return null;

  return (
    <section className={css.root}>
      <div className={css.accent} aria-hidden="true" />
      <div className={css.body}>
        <div className={css.label}>Pay over time</div>
        <h3 className={css.title}>Split this booking into installments</h3>
        <p className={css.copy}>
          Pay half now and half a week before pickup, or weekly through your rental date.
          Financing fees apply.
        </p>
      </div>
    </section>
  );
};

export default SectionPaymentPlanMaybe;
